export default {
  boards: 'id,name,background',
  lists: 'id,name,board',
  cards: 'id,name,order,list,board'
}
